import React from "react";
import PaywallIncludes from "./PaywallIncludes";
import PaywallIOSPriceCard from "./PaywallIOSPriceCard";
import PaywallIOSDisclosure from "./PaywallIOSDisclosure";

/**
 * Dev-only preview of the iOS paywall — renders the exact Build 38 layout
 * with hard-coded mock RevenueCat data so we can produce an App Store
 * Connect "Subscription Review Information → Screenshot" image without
 * needing a real iOS build.
 *
 * This route is NOT linked from anywhere in the app. It exists purely so
 * the marketing/legal team can capture a clean, marketing-grade frame of
 * the paywall layout via Playwright or a manual screenshot.
 *
 * URL: /dev/paywall-preview
 */
const MOCK_OFFERINGS = [
  {
    identifier: "sub_yearly",
    title: "TipLingo Pro Yearly",
    price_string: "$39.99",
    period: "year",
    // T49.T (Build 81) — trial label removed pending ASC offer.
  },
  {
    identifier: "sub_monthly",
    title: "TipLingo Pro Monthly",
    price_string: "$4.99",
    period: "month",
  },
];

const SAVINGS_LABEL = "Save $19.89 compared to monthly";

export default function PaywallIOSPreview() {
  return (
    <div className="min-h-screen bg-navy/40 flex items-start justify-center py-6">
      <div className="w-full max-w-2xl bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col mx-4">
        {/* Sheet header — mirrors Paywall.jsx header */}
        <div className="px-5 sm:px-8 pt-5 pb-3 bg-white shrink-0">
          <div className="w-12 h-1.5 bg-navy/15 rounded-full mx-auto mb-3" />
          <h1 className="font-jakarta font-extrabold text-3xl sm:text-4xl text-navy text-center">
            Go <span className="text-orange">Pro</span>
          </h1>
          <p className="text-sm sm:text-base text-navy-soft font-jakarta font-semibold text-center mt-1">
            Unlock Pro travel tools for every trip
          </p>
        </div>

        <div className="overflow-y-auto px-5 sm:px-8 pt-3 pb-7 space-y-5">
          <PaywallIncludes />

          {/* Subscriptions header */}
          <div>
            <div className="text-navy-soft text-[11px] uppercase tracking-[0.2em] font-jakarta font-bold mb-3 flex items-center gap-2">
              <span className="h-px flex-1 bg-navy/10" />
              Subscriptions
              <span className="h-px flex-1 bg-navy/10" />
            </div>
            <div className="space-y-4">
              {MOCK_OFFERINGS.map((p) => (
                <PaywallIOSPriceCard
                  key={p.identifier}
                  pkg={p}
                  busy={false}
                  onBuy={() => {}}
                  isBestValue={p.period === "year"}
                  savingsLabel={p.period === "year" ? SAVINGS_LABEL : null}
                  flexLabel={
                    p.period === "month" ? "Flexible monthly billing" : null
                  }
                />
              ))}
            </div>
          </div>

          {/* Apple-mandated disclosure block — Terms · Privacy · Restore
              live inline in the disclosure footer per the V2 design. */}
          <PaywallIOSDisclosure onRestore={() => {}} />
        </div>
      </div>
    </div>
  );
}
